// extracted by mini-css-extract-plugin
export default {"errorWrapper":"error_errorWrapper__pnuDu","illustration":"error_illustration__yuftL"};